import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DailyReportsService} from '../../../services/daily-reports.service';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'daily-reports-view-report-modal',
    templateUrl: 'daily-reports-view-report-modal.component.html',
    styleUrls: ['./daily-reports-view-report-modal.component.scss']
})
export class DailyReportsViewReportModalComponent implements OnInit {
    dailyReportNumber: string;
    showModal = true;
    data = null;
    showSpinner = false;
    entries: Array<any> = [];

    constructor(
        public dailyReportsService: DailyReportsService,
        public api: ApiClientService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.dailyReportNumber      = this.dailyReportsService.dailyReportInDailyReportsModal.dailyReportNumber;
        this.data = this.dailyReportsService.dailyReportInDailyReportsModal;
        this.entries = this.dailyReportsService.dailyReportInDailyReportsModal.entries;
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        this.dailyReportsService.showDailyEntriesModal = false;
        this.dailyReportsService.dailyReportInDailyReportsModal = null;
        this.urlService.modalClosed.emit();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-view-report-modal/daily-reports-view-report-modal.component.ts